import { eDanhBaSinhVienActionsObj } from "../../action-types/category/IDanhBaSinhVienActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhBaSinhVienActions = {
  ...generateActions(eDanhBaSinhVienActionsObj, "DANH_BA_SINH_VIEN"),
};
